<template>
  <Layout>
    <div style="margin-bottom:10px">
      <span class="analysis-time" style="cursor: pointer" @click="setDate(0)"
        >今天</span
      >
      <span class="analysis-time" style="cursor: pointer" @click="setDate(-1)"
        >昨天</span
      ><span class="analysis-time" style="cursor: pointer" @click="setDate(-7)"
        >最近7天</span
      ><span class="analysis-time" style="cursor: pointer" @click="setDate(-30)"
        >最近30天</span
      >
      <el-date-picker
        v-model="daterange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
      >
      </el-date-picker>
      <span style="margin-left:20px;font-weight:bold"
        >媒体号关注人数：{{ mediaFollowNum }}</span
      >
    </div>

    <div class="row col-lg-12">
      <div class="col-lg-6">
        <chartLine
          type="ARTICLE_NUM"
          @change="exportData"
          :style="{ width: '100%', height: '300px' }"
          title="媒体号文章浏览量"
          :line-data-s="articleViewS"
          :line-data-x="articleViewX"
        ></chartLine>
      </div>
      <div class="col-lg-6">
        <chartLine
          type="VIDEO_NUM"
          @change="exportData"
          :style="{ width: '100%', height: '300px' }"
          title="媒体号视频浏览量"
          :line-data-s="videoViewS"
          :line-data-x="videoViewX"
        ></chartLine>
      </div>
    </div>

    <div class="row col-lg-12">
      <div class="col-lg-6">
        <chartLine
          type="ARTICLE_PUBLISH"
          @change="exportData"
          :style="{ width: '100%', height: '300px' }"
          title="媒体号文章发布数"
          :line-data-s="articlePublishS"
          :line-data-x="articlePublishX"
        ></chartLine>
      </div>
      <div class="col-lg-6">
        <chartLine
          type="VIDEO_PUBLISH"
          @change="exportData"
          :style="{ width: '100%', height: '300px' }"
          title="媒体号视频发布数"
          :line-data-s="videoPublishS"
          :line-data-x="videoPublishX"
        ></chartLine>
      </div>
    </div>

    <!-- <div class="row col-lg-12">
      <div class="col-lg-6">
        <label class="col-form-label col-lg-6 input_text"
          >媒体号内容被收藏数</label
        >
        <div class="header-item-fix">
          <b-button variant="primary" size="sm" @click="downloadTopFav()">
            <i class="bx bx-export font-size-16">导出</i>
          </b-button>
        </div>
        <div class="table-responsive">
          <table
            class="table table-nowrap table-centered table-striped align-middle"
          >
            <thead>
              <tr>
                <th scope="col">媒体号名称</th>
                <th scope="col">
                  <span>数值</span
                  ><i
                    class="el-icon-bottom media-sort-icon"
                    @click="sort_collection('desc')"
                    :style="{
                      color:
                        search_collection.sort == 'desc' ? 'black' : 'gray',
                    }"
                  />
                  <i
                    class="el-icon-top media-sort-icon"
                    @click="sort_collection('asc')"
                    :style="{
                      color:
                        search_collection.sort == 'desc' ? 'gray' : 'black',
                    }"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in collection_list" :key="index">
                <td>{{ list.userName }}</td>
                <td>{{ list.num }}</td>
              </tr>
              <tr v-if="!collection_list.length">
                <td colspan="6" style="text-align: center !important">
                  暂无数据
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageSize="search_collection.pageSize"
          @pageCallback="pageChange_collection"
          :page.sync="search_collection.page"
          layout="total, prev, pager, next"
          :total="total_collection"
        ></pagination>
      </div>

      <div class="col-lg-6">
        <label class="col-form-label col-lg-6 input_text">媒体号内容发布</label>
        <div class="header-item-fix">
          <b-button variant="primary" size="sm" @click="downloadTopContent()">
            <i class="bx bx-export font-size-16">导出</i>
          </b-button>
        </div>
        <div class="table-responsive">
          <table
            class="table table-nowrap table-centered table-striped align-middle"
          >
            <thead>
              <tr>
                <th scope="col">媒体号名称</th>
                <th scope="col">
                  <span>数值</span
                  ><i
                    class="el-icon-bottom media-sort-icon"
                    @click="sort_content('desc')"
                    :style="{
                      color: search_content.sort == 'desc' ? 'black' : 'gray',
                    }"
                  />
                  <i
                    class="el-icon-top media-sort-icon"
                    @click="sort_content('asc')"
                    :style="{
                      color: search_content.sort == 'desc' ? 'gray' : 'black',
                    }"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in content_list" :key="index">
                <td>{{ list.userName }}</td>
                <td>{{ list.num }}</td>
              </tr>
              <tr v-if="!content_list.length">
                <td colspan="6" style="text-align: center !important">
                  暂无数据
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageSize="search_content.pageSize"
          @pageCallback="pageChange_content"
          :page.sync="search_content.page"
          layout="total, prev, pager, next"
          :total="total_content"
        ></pagination>
      </div>
    </div>

    <div class="row col-lg-12">
      <div class="col-lg-6">
        <label class="col-form-label col-lg-6 input_text">媒体号关注数</label>
        <div class="header-item-fix">
          <b-button variant="primary" size="sm" @click="downloadTopFollow()">
            <i class="bx bx-export font-size-16">导出</i>
          </b-button>
        </div>
        <div class="table-responsive">
          <table
            class="table table-nowrap table-centered table-striped align-middle"
          >
            <thead>
              <tr>
                <th scope="col">媒体号名称</th>
                <th scope="col">
                  <span>数值</span
                  ><i
                    class="el-icon-bottom media-sort-icon"
                    @click="sort_follow('desc')"
                    :style="{
                      color: search_follow.sort == 'desc' ? 'black' : 'gray',
                    }"
                  />
                  <i
                    class="el-icon-top media-sort-icon"
                    @click="sort_follow('asc')"
                    :style="{
                      color: search_follow.sort == 'desc' ? 'gray' : 'black',
                    }"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in follow_list" :key="index">
                <td>{{ list.followName }}</td>
                <td>{{ list.followCount }}</td>
              </tr>
              <tr v-if="!follow_list.length">
                <td colspan="6" style="text-align: center !important">
                  暂无数据
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageSize="search_follow.pageSize"
          @pageCallback="pageChange_follow"
          :page.sync="search_follow.page"
          layout="total, prev, pager, next"
          :total="total_follow"
        ></pagination>
      </div>

      <div class="col-lg-6">
        <label class="col-form-label col-lg-6 input_text">媒体号内容浏览</label>
        <div class="header-item-fix">
          <b-button variant="primary" size="sm" @click="downloadTopViewNum()">
            <i class="bx bx-export font-size-16">导出</i>
          </b-button>
        </div>
        <div class="table-responsive">
          <table
            class="table table-nowrap table-centered table-striped align-middle"
          >
            <thead>
              <tr>
                <th scope="col">媒体号名称</th>
                <th scope="col">
                  <span>数值</span
                  ><i
                    class="el-icon-bottom media-sort-icon"
                    @click="sort_view('desc')"
                    :style="{
                      color: search_view.sort == 'desc' ? 'black' : 'gray',
                    }"
                  />
                  <i
                    class="el-icon-top media-sort-icon"
                    @click="sort_view('asc')"
                    :style="{
                      color: search_view.sort == 'desc' ? 'gray' : 'black',
                    }"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in view_list" :key="index">
                <td>{{ list.userName }}</td>
                <td>{{ list.num }}</td>
              </tr>
              <tr v-if="!view_list.length">
                <td colspan="6" style="text-align: center !important">
                  暂无数据
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageSize="search_view.pageSize"
          @pageCallback="pageChange_view"
          :page.sync="search_view.page"
          layout="total, prev, pager, next"
          :total="total_view"
        ></pagination>
      </div>

      <div class="col-lg-6">
        <label class="col-form-label col-lg-6 input_text">媒体号帖子数</label>
        <div class="header-item-fix">
          <b-button variant="primary" size="sm" @click="downloadPost()">
            <i class="bx bx-export font-size-16">导出</i>
          </b-button>
        </div>
        <div class="table-responsive">
          <table
            class="table table-nowrap table-centered table-striped align-middle"
          >
            <thead>
              <tr>
                <th scope="col">媒体号名称</th>
                <th scope="col">
                  <span>数值</span
                  ><i
                    class="el-icon-bottom media-sort-icon"
                    @click="sort_post('desc')"
                    :style="{
                      color: search_post.sort == 'desc' ? 'black' : 'gray',
                    }"
                  />
                  <i
                    class="el-icon-top media-sort-icon"
                    @click="sort_post('asc')"
                    :style="{
                      color: search_post.sort == 'desc' ? 'gray' : 'black',
                    }"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in post_list" :key="index">
                <td>{{ list.userName }}</td>
                <td>{{ list.num }}</td>
              </tr>
              <tr v-if="!post_list.length">
                <td colspan="6" style="text-align: center !important">
                  暂无数据
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageSize="search_post.pageSize"
          @pageCallback="pageChange_post"
          :page.sync="search_post.page"
          layout="total, prev, pager, next"
          :total="total_post"
        ></pagination>
      </div>
    </div> -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import chartLine from "@/router/views/dashboards/chartLine";
import Vue from "vue";
import api from "@/server/api/mediaStat";
import pagination from "@/components/pagination/pagination.vue";

/**
 * Tabs & accordions component
 */
export default {
  components: {
    Layout,
    chartLine,
    pagination,
  },
  data() {
    return {
      articleViewS: [],
      articleViewX: [],
      videoViewS: [],
      videoViewX: [],
      articlePublishS: [],
      articlePublishX: [],
      videoPublishS: [],
      videoPublishX: [],
      listData: [],
      LikeX: [],
      LikeS: [],
      FollowX: [],
      FollowS: [],
      content_list: [],
      follow_list: [],
      collection_list: [],
      view_list: [],
      post_list: [],
      daterange: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      search_collection: {
        page: 1,
        pageSize: 10,
        sort: "desc",
      },
      total_collection: 0,
      search_content: {
        page: 1,
        pageSize: 10,
        sort: "desc",
      },
      total_content: 0,
      search_follow: {
        page: 1,
        pageSize: 10,
        sort: "desc",
      },
      total_follow: 0,
      search_view: {
        page: 1,
        pageSize: 10,
        sort: "desc",
      },
      total_view: 0,
      search_post: {
        page: 1,
        pageSize: 10,
        sort: "desc",
      },
      total_post: 0,
      mediaFollowNum: 0, //媒体号关注人数
    };
  },

  mounted() {
    this.init();
  },

  created() {
    console.log("媒体号信息加载了");
    // this.getCollectionList();
    // this.getContentList();
    // this.getFollowList();
    // this.getViewList();
    // this.getPostList();
  },

  watch: {
    daterange() {
      // this.getData(false);
      this.getMediaData();
    },
  },

  methods: {
    init() {
      this.setDate(-7);
      this.getFollowList();
    },
    // 设置时间，点击最近几天的时候
    setDate(day) {
      if (day == 0) {
        this.endDate = this.getDateStr(0);
      } else {
        this.endDate = this.getDateStr(-1);
      }
      this.startDate = this.getDateStr(day);
      let daterange = [];
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() + 3600 * 1000 * 24 * day);
      daterange.push(start);
      daterange.push(end);
      this.daterange = daterange;
      // this.getData();
    },
    // 获取时间，参数为-1代表昨天到今天，-30为最近30天
    getDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount);
      var y = dd.getYear() + 1900;
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    exportData(data) {
      if (data == "FollowCount") {
        this.downloadFollow();
      } else if (data == "FavCount") {
        this.downloadLike();
      } else {
        this.downloadData(data);
      }
    },
    // href下载
    downloadTopFollow() {
      let url =
        env.API_HOST + "/chart/get_media_account_top_follow_state_export";

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    downloadTopContent() {
      let url =
        env.API_HOST + "/chart/get_media_account_top_content_state_export";

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    downloadTopFav() {
      let url = env.API_HOST + "/chart/get_media_account_top_fav_state_export";

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    downloadTopViewNum() {
      let url =
        env.API_HOST + "/chart/get_media_account_top_view_num_state_export";

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    downloadPost() {
      let url = env.API_HOST + "/chart/top/post/export";
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    // href下载
    downloadLike() {
      let params = {};
      if (this.daterange.length) {
        params.startDate = this.daterange[0].format("yyyy-MM-dd");
        params.endDate = this.daterange[1].format("yyyy-MM-dd");
      } else {
        Vue.swal("请选择有效时间");
        return;
      }

      let url =
        env.API_HOST +
        "/chart/get_content_like_state_export?startDate=" +
        params.startDate +
        "&endDate=" +
        params.endDate;

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },

    downloadFollow() {
      let params = {};
      if (this.daterange.length) {
        params.startDate = this.daterange[0].format("yyyy-MM-dd");
        params.endDate = this.daterange[1].format("yyyy-MM-dd");
      } else {
        Vue.swal("请选择有效时间");
        return;
      }

      let url =
        env.API_HOST +
        "/chart/get_media_followers_state_export?startDate=" +
        params.startDate +
        "&endDate=" +
        params.endDate;

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    async getData(isExport = false) {
      this.getMediaFollowStat(false);
      this.getMediaLikeStat(false);
      // this.getMediaTopStat(false);
    },
    getMediaLikeStat(isExport = false) {
      let params = {};
      if (this.daterange.length) {
        params.startDate = this.daterange[0].format("yyyy-MM-dd");
        params.endDate = this.daterange[1].format("yyyy-MM-dd");
      } else {
        Vue.swal("请选择有效时间");
        return;
      }
      let that = this;
      if (isExport) {
        this.download(params.platform);
      } else {
        api.likeStat(params).then((resp) => {
          if (resp.data) {
            let row = resp.data;
            that.LikeS = [];
            that.LikeX = [];

            for (let i = 0; i < row.length; i++) {
              var itemvalue = row[i];
              that.LikeS.push(itemvalue.num);
              that.LikeX.push(itemvalue.date);
            }
          }
        });
      }
    },

    getMediaFollowStat(isExport = false) {
      let params = {};
      if (this.daterange.length) {
        params.startDate = this.daterange[0].format("yyyy-MM-dd");
        params.endDate = this.daterange[1].format("yyyy-MM-dd");
      } else {
        Vue.swal("请选择有效时间");
        return;
      }
      let that = this;
      if (isExport) {
        this.download(params.platform);
      } else {
        api.followStat(params).then((resp) => {
          if (resp.data) {
            let row = resp.data;
            that.FollowS = [];
            that.FollowX = [];

            for (let i = 0; i < row.length; i++) {
              var itemvalue = row[i];
              that.FollowS.push(itemvalue.num);
              that.FollowX.push(itemvalue.date);
            }
          }
        });
      }
    },

    // getMediaTopStat(isExport = false) {
    //   let params = {};

    //   let that = this;
    //   if (isExport) {
    //     this.download(params.platform);
    //   } else {
    //     api.topStat(params).then((resp) => {
    //       if (resp.data) {
    //         this.content_list = resp.data.topContentMediaDtoList;
    //         this.collection_list = resp.data.topFollowDtoList;
    //         this.follow_list = resp.data.topFavMediaDtoList;
    //         this.view_list = resp.data.topViewNumMediaDtoList;
    //       }
    //     });
    //   }
    // },
    // href下载
    download(platform) {
      let url =
        env.API_HOST +
        "/tpns/get_push_channel_stat_overview?startDate=" +
        this.startDate +
        "&endDate=" +
        this.endDate +
        "&platform=" +
        platform;
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    //收藏数
    getCollectionList(page) {
      if (typeof page == "number") {
        this.search_collection.page = page;
      }
      api.collectionList(this.search_collection).then((res) => {
        console.log("收藏数", res);
        if (res.code === 0) {
          this.collection_list = res.data.items;
          this.total_collection = res.data.total;
        }
      });
    },
    pageChange_collection(obj) {
      if (obj.code == "page") {
        this.search_collection.page = obj.page;
      }
      this.getCollectionList();
    },
    sort_collection(type) {
      if (this.search_collection.sort != type) {
        this.search_collection.sort = type;
        this.getCollectionList(1);
      }
    },
    //内容发布
    getContentList(page) {
      if (typeof page == "number") {
        this.search_content.page = page;
      }
      api.contentList(this.search_content).then((res) => {
        console.log("内容数", res);
        if (res.code === 0) {
          this.content_list = res.data.items;
          this.total_content = res.data.total;
        }
      });
    },
    pageChange_content(obj) {
      if (obj.code == "page") {
        this.search_content.page = obj.page;
      }
      this.getContentList();
    },
    sort_content(type) {
      if (this.search_content.sort != type) {
        this.search_content.sort = type;
        this.getContentList(1);
      }
    },

    //关注数
    getFollowList(page) {
      if (typeof page == "number") {
        this.search_follow.page = page;
      }
      api.followList(this.search_follow).then((res) => {
        console.log("关注数", res);
        if (res.code === 0) {
          this.follow_list = res.data.items;
          this.total_follow = res.data.total;
        }
      });
    },
    pageChange_follow(obj) {
      if (obj.code == "page") {
        this.search_follow.page = obj.page;
      }
      this.getFollowList();
    },
    sort_follow(type) {
      if (this.search_follow.sort != type) {
        this.search_follow.sort = type;
        this.getFollowList(1);
      }
    },

    //内容浏览
    getViewList(page) {
      if (typeof page == "number") {
        this.search_view.page = page;
      }
      api.viewList(this.search_view).then((res) => {
        console.log("浏览数", res);
        if (res.code === 0) {
          this.view_list = res.data.items;
          this.total_view = res.data.total;
        }
      });
    },
    pageChange_view(obj) {
      if (obj.code == "page") {
        this.search_view.page = obj.page;
      }
      this.getViewList();
    },
    sort_view(type) {
      if (this.search_view.sort != type) {
        this.search_view.sort = type;
        this.getViewList(1);
      }
    },

    //帖子数
    getPostList(page) {
      if (typeof page == "number") {
        this.search_post.page = page;
      }
      api.postList(this.search_post).then((res) => {
        console.log("帖子数", res);
        if (res.code === 0) {
          this.post_list = res.data.items;
          this.total_post = res.data.total;
        }
      });
    },
    pageChange_post(obj) {
      if (obj.code == "page") {
        this.search_post.page = obj.page;
      }
      this.getPostList();
    },
    sort_post(type) {
      if (this.search_post.sort != type) {
        this.search_post.sort = type;
        this.getPostList(1);
      }
    },
    async getMediaData() {
      this.videoViewS = [];
      this.videoViewX = [];
      this.articleViewX = [];
      this.articleViewS = [];
      this.videoPublishS = [];
      this.videoPublishX = [];
      this.articlePublishS = [];
      this.articlePublishX = [];
      let params = {
        mediaId: JSON.parse(localStorage.chosedMedia).id,
      };
      if (Array.isArray(this.daterange) && this.daterange.length) {
        params.startDate = this.daterange[0].format("yyyy-MM-dd");
        params.endDate = this.daterange[1].format("yyyy-MM-dd");
      } else {
        this.warning("请选择有效时间");
        return;
      }
      await api
        .contentViewNum({ type: "ARTICLE_NUM", ...params })
        .then((res) => {
          if (res.code === 0) {
            console.log("文章浏览数", res);
            if (res.data && res.data.length) {
              res.data.forEach((item) => {
                this.articleViewS.push(item.num);
                this.articleViewX.push(item.date);
              });
            }
          }
        });
      await api.contentViewNum({ type: "VIDEO_NUM", ...params }).then((res) => {
        if (res.code === 0) {
          console.log("视频浏览数", res);
          if (res.data && res.data.length) {
            res.data.forEach((item) => {
              this.videoViewS.push(item.num);
              this.videoViewX.push(item.date);
            });
          }
        }
      });
      await api
        .contentViewNum({ type: "ARTICLE_PUBLISH", ...params })
        .then((res) => {
          if (res.code === 0) {
            console.log("文章发布数", res);
            if (res.data && res.data.length) {
              res.data.forEach((item) => {
                this.articlePublishS.push(item.num);
                this.articlePublishX.push(item.date);
              });
            }
          }
        });
      await api
        .contentViewNum({ type: "VIDEO_PUBLISH", ...params })
        .then((res) => {
          if (res.code === 0) {
            console.log("视频发布数", res);
            if (res.data && res.data.length) {
              res.data.forEach((item) => {
                this.videoPublishS.push(item.num);
                this.videoPublishX.push(item.date);
              });
            }
          } else {
            this.warning(res.msg);
          }
        });
    },
    downloadData(type) {
      let params = {
        mediaId: JSON.parse(localStorage.chosedMedia).id,
        type,
      };
      if (this.daterange.length) {
        params.startDate = this.daterange[0].format("yyyy-MM-dd");
        params.endDate = this.daterange[1].format("yyyy-MM-dd");
      } else {
        Vue.swal("请选择有效时间");
        return;
      }
      let name = "";
      if (type == "ARTICLE_NUM") {
        name = "媒体号文章浏览量";
      } else if (type == "VIDEO_NUM") {
        name = "媒体号视频浏览量";
      } else if (type == "ARTICLE_PUBLISH") {
        name = "媒体号文章发布数";
      } else if (type == "VIDEO_PUBLISH") {
        name = "媒体号视频发布数";
      }
      name = name + " " + params.startDate + "_" + params.endDate;
      let url =
        env.API_HOST +
        "/chart/media/content/export?startDate=" +
        params.startDate +
        "&endDate=" +
        params.endDate +
        "&type=" +
        params.type +
        "&mediaId=" +
        params.mediaId +
        "&name=" +
        name;

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      // a.download = '订单模板.xls';
      a.click();
      a.remove();
    },
    //关注数
    getFollowList() {
      api
        .followList({
          mediaId: JSON.parse(localStorage.chosedMedia).id,
        })
        .then((res) => {
          console.log("关注数", res);
          if (res.code === 0) {
            if (Array.isArray(res.data.items) && res.data.items[0]) {
              this.mediaFollowNum = res.data.items[0].followCount;
            }
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.media-sort-icon {
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
}
.analysis-time {
  margin-right: 20px;
}
.analysis-head {
  padding-left: 15px;
  margin-bottom: 10px;
}
</style>
